import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const logoLoaderAreas = [
  {
    styles: {
      width: '32px',
      height: '32px',
      borderRadius: '40px',
    },
  },
];

export const nameLoaderAreas = [
  {
    styles: {
      width: '114px',
      height: '24px',
      borderRadius: '8px',
    },
  },
];

export const rankLoaderAreas = [
  {
    styles: {
      width: '48px',
      height: '24px',
      borderRadius: '8px',
    },
  },
];
